import React from 'react';
import AboutSection from '../../components/about/AboutSection';
import Footer from '../../components/footer/footer';
import Navbar from '../../components/navbar/nav';
import MisionVision from '../../components/MisionVision/MisionVision';
import './about.css';

function AboutLayout() {
    return (
        <div className="about-layout">
            <Navbar />

            <main className="about-main">
                {/* Hero section */}
                <section className="about-hero">
                    <video className="about-hero-video" autoPlay loop muted playsInline>
                        <source src="/videos/tape1.mp4" type="video/mp4" />
                        Tu navegador no soporta la reproducción de video.
                    </video>

                    <div className="about-hero-overlay"></div>

                    <div className="about-hero-content text-center text-white">
                        <h1 className="display-4 fw-bold">
                            Llevamos el futuro del audio a Colombia
                        </h1>
                        <p className="lead">
                            Desde 2017, acercamos las mejores marcas de audio profesional
                            para inspirar a músicos, ingenieros y creadores.
                        </p>
                    </div>
                </section>

                {/* Valores optimizados */}
                <section className="values-section py-5">
                    <div className="container">
                        <h2 className="text-center mb-5">Lo que nos hace diferentes</h2>
                        <div className="row g-4">
                            <div className="col-md-4">
                                <div className="card h-100 border-0 shadow-sm">
                                    <div className="card-body text-center">
                                        <i className="bi bi-lightning-charge-fill fs-1 text-primary mb-3"></i>
                                        <h3 className="h4">Innovación Sonora</h3>
                                        <p className="text-muted">
                                            Traemos a Colombia las últimas tecnologías en audio
                                            para que tus proyectos suenen como en cualquier estudio del mundo.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card h-100 border-0 shadow-sm">
                                    <div className="card-body text-center">
                                        <i className="bi bi-award-fill fs-1 text-primary mb-3"></i>
                                        <h3 className="h4">Calidad sin Compromisos</h3>
                                        <p className="text-muted">
                                            Solo trabajamos con marcas reconocidas por su rendimiento y durabilidad.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card h-100 border-0 shadow-sm">
                                    <div className="card-body text-center">
                                        <i className="bi bi-music-note-beamed fs-1 text-primary mb-3"></i>
                                        <h3 className="h4">Conexión con el Artista</h3>
                                        <p className="text-muted">
                                            Escuchamos tus necesidades para ofrecerte la mejor solución
                                            técnica y creativa.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <br />
                        <MisionVision />
                    </div>
                </section>

                {/* Historia mejorada */}
                <section className="about-additional bg-light py-5">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <img
                                    src="/images/recmachine1.jpg"
                                    alt="Nuestra Historia"
                                    className="img-fluid rounded shadow-lg"
                                />
                            </div>
                            <div className="col-md-6">
                                <h2 className="display-6 mb-4">Nuestra Historia</h2>
                                <p className="lead">
                                    Vintage Pro Audio fue fundada por <strong>Andres Felipe Sanchez</strong>,
                                    ingeniero y productor de audio egresado de la Escuela de Música y Audio Fernando Sor
                                    en Bogotá, Colombia.
                                </p>
                                <p>
                                    Desde <strong>2017</strong>, Andres ha trabajado con una visión clara: acercar a Colombia
                                    tecnologías de vanguardia en procesamiento de audio, impulsando la calidad del sonido
                                    en postproducción, sonido en vivo y grabación en estudio.
                                </p>
                                <p>
                                    Aunque la empresa nació oficialmente en formato digital en <strong>2025</strong>,
                                    el proyecto comenzó en <strong>2019</strong> como un sueño para democratizar el acceso
                                    a la tecnología profesional. Hoy, ese sueño es realidad, y nuestra misión es contribuir
                                    al futuro del arte, la música y la producción audiovisual.
                                </p>
                                <div className="d-flex gap-3 mt-4">
                                    <div className="text-center">
                                        <h3 className="display-6 fw-bold text-primary">15+</h3>
                                        <p className="text-muted">Años de experiencia</p>
                                    </div>
                                    <div className="text-center">
                                        <h3 className="display-6 fw-bold text-primary">1000+</h3>
                                        <p className="text-muted">Clientes satisfechos</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <AboutSection />
            </main>
            <Footer />
        </div>
    );
}

export default AboutLayout;
